import cx from 'classnames'
import { observer } from 'mobx-react-lite'
import { VisualSwitch } from 'components/VisualSwitch/VisualSwitch'
import { Button } from 'components/Button'
import Styles from './TrackChangesButtons.module.scss'
import { MarkupDecorationsChanges } from 'almanac-ui/icons/24'
import { useDocStore } from 'stores/DocStore'

const ToggleTrackedChangesButton = observer(() => {
  const docStore = useDocStore()

  const { hideDecorations, toggleDecorations } = docStore.trackedChangesStore

  return (
    <Button
      size="md"
      onPress={toggleDecorations}
      variant="tertiary"
      frontIcon={MarkupDecorationsChanges}
      iconClassName={cx(Styles.icon, Styles.doubleClassOverride)}
      className={cx(Styles.button, Styles.doubleClassOverride)}
    >
      <span className={Styles.label}>
        <span>Show changes</span>
        <VisualSwitch active={!hideDecorations} />
      </span>
    </Button>
  )
})

export { ToggleTrackedChangesButton }
